<template>
  <div
    class="bg-background-neutral-onblock flex space-x-2 rounded-xl px-2 py-3"
  >
    <div
      v-if="isHandLuggageVisible && !newHandLuggageValue"
      class="flex items-center space-x-1"
      :class="
        !handLuggage
          ? 'text-text-neutral-quaternary'
          : 'text-text-positive-primary'
      "
    >
      <!-- eslint-disable -->
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        fill="none"
        viewBox="0 0 24 24"
        class="flex-shrink-0"
      >
        <path
          fill="currentColor"
          fill-rule="evenodd"
          d="M13.729 2h-3.46A2.092 2.092 0 0 0 8.32 3.293a2.11 2.11 0 0 0-.161.807v1.627a7.447 7.447 0 0 0-3.575 6.35v.775h-.842A1.752 1.752 0 0 0 2 14.564v3.567a1.752 1.752 0 0 0 1.747 1.75h.838v1.045a1.131 1.131 0 0 0 1.108 1.071h12.653a1.127 1.127 0 0 0 1.07-1.11v-1.03h.837A1.745 1.745 0 0 0 22 18.108v-3.53a1.752 1.752 0 0 0-1.747-1.75h-.837v-.75a7.447 7.447 0 0 0-3.591-6.36V4.09A2.122 2.122 0 0 0 13.74 2h-.011Zm.599 3.027v-.92a.62.62 0 0 0-.606-.607H10.26a.598.598 0 0 0-.603.6v.932a7.41 7.41 0 0 1 2.342-.384h.002a7.41 7.41 0 0 1 2.327.379Zm3.59 8.536V12.08a5.946 5.946 0 0 0-1.736-4.19A5.923 5.923 0 0 0 12 6.148a5.922 5.922 0 0 0-4.182 1.74 5.946 5.946 0 0 0-1.736 4.19v8.419H7.56a1.758 1.758 0 0 1-.047-.404v-3.34a2.747 2.747 0 0 1 2.744-2.75h3.473a2.747 2.747 0 0 1 2.745 2.75v.497a.764.764 0 0 1 0 .217v2.626c0 .14-.016.275-.047.404h1.49v-6.934Zm2.335 4.795h-.837v-4.03h.837a.25.25 0 0 1 .25.25v3.53a.25.25 0 0 1-.25.25ZM4.585 14.352v4.03h-.838a.25.25 0 0 1-.25-.25v-3.538a.25.25 0 0 1 .075-.167l.003-.003a.249.249 0 0 1 .174-.072h.836Zm10.385 2.257a1.249 1.249 0 0 0-1.24-1.105h-3.473a1.25 1.25 0 0 0-1.24 1.105h5.953Zm-5.96 1.5v1.985c0 .138.111.25.25.25h5.469a.25.25 0 0 0 .249-.25v-1.985H9.01Zm2.46-9.96a.75.75 0 0 0 0 1.5h1.048a.75.75 0 0 0 0-1.5H11.47Z"
          clip-rule="evenodd"
        />
      </svg>
      <!-- eslint-enable -->
      <!-- Using component to control where to wrap the string -->
      <i18n-t
        tag="p"
        class="text-wrap text-xs font-medium"
        :keypath="!handLuggage ? 'handLuggageMissing' : 'handLuggage'"
      >
        <template #handLuggage>
          <span class="text-nowrap">
            {{ handLuggage }}
          </span>
        </template>
      </i18n-t>
    </div>
    <div
      v-if="isBaggageVisible"
      class="flex items-center space-x-1"
      :class="
        !baggage ? 'text-text-neutral-quaternary' : 'text-text-positive-primary'
      "
    >
      <!-- eslint-disable -->
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        fill="none"
        viewBox="0 0 24 24"
        class="flex-shrink-0"
      >
        <path
          fill="currentColor"
          fill-rule="evenodd"
          d="M10.897 2.098h2.2c.032 0 .064.001.095.004h3.563c.31 0 .561.25.561.56a.935.935 0 0 1-.935.936h-1.69v.982a.753.753 0 0 1-.006.092h2.495a2.25 2.25 0 0 1 2.25 2.25v11.59a2.25 2.25 0 0 1-2.25 2.25H6.82a2.25 2.25 0 0 1-2.25-2.25V6.922a2.25 2.25 0 0 1 2.25-2.25h2.47a.759.759 0 0 1-.005-.092v-.983H7.62a.935.935 0 0 1-.935-.934c0-.31.25-.561.56-.561h3.529c.041-.003.082-.005.124-.004Zm-.117 2.574h2.417a.753.753 0 0 1-.006-.092v-.944l-.002-.002a.174.174 0 0 0-.108-.036h-2.193a.196.196 0 0 0-.066.01.122.122 0 0 0-.037.021v.951a.753.753 0 0 1-.005.092Zm-.061 2.976a.75.75 0 0 1 .75-.75h1.05a.75.75 0 1 1 0 1.5h-1.05a.75.75 0 0 1-.75-.75Zm-3.27 13.5a.75.75 0 0 0 0 1.5H8.5a.75.75 0 1 0 0-1.5H7.45Zm8.05 0a.75.75 0 0 0 0 1.5h1.05a.75.75 0 1 0 0-1.5H15.5ZM6.07 6.922a.75.75 0 0 1 .75-.75h10.36a.75.75 0 0 1 .75.75v11.59a.75.75 0 0 1-.75.75H6.82a.75.75 0 0 1-.75-.75V6.922Z"
          clip-rule="evenodd"
        />
      </svg>
      <!-- eslint-enable -->
      <!-- Using component to control where to wrap the string -->
      <i18n-t
        tag="p"
        class="text-wrap text-xs font-medium"
        :keypath="!baggage ? 'baggageMissing' : 'baggage'"
      >
        <template #baggage>
          <span class="text-nowrap">
            {{ baggage }}
          </span>
        </template>
      </i18n-t>
    </div>
  </div>
</template>

<script setup lang="ts">
  import { useI18n } from 'vue-i18n';

  defineProps<{
    baggage: string;
    handLuggage: string;
    isBaggageVisible?: boolean;
    isHandLuggageVisible?: boolean;
    newHandLuggageValue?: number;
  }>();

  // leaving it here, for whatever reason translation component doesn't work without calling composable
  // eslint-disable-next-line
  const { t } = useI18n();
</script>

<i18n src="../../config/locales.json"></i18n>
